<template>
  <div>
    <slot :open="open"></slot>
    <div
      :class="{
        'is-toggled': video_modal_open
      }"
      class="sidearm-mm__video-modal flex flex-align-center flex-justify-center"
      v-dom-portal
    >
      <div class="sidearm-mm__video-modal-inner flex flex-column">
        <div class="sidearm-mm__video-modal-header text-right mb-2">
          <button
            @click="toggle_video_modal(false)"
            type="button"
            class="sidearm-mm__video-modal-close type-paragraph-large text-bold"
            aria-label="Close video"
          >
            <span>Close</span>
            <icon size="1.625rem">sf-close-minimal</icon>
          </button>
        </div>

        <div
          class="sidearm-mm__video-modal-player-container relative overflow-hidden"
        >
          <div class="sidearm-mm__video-modal-player-wrapper">
            <div
              v-if="video.type === 'youtube'"
              :id="`modal_video${id}`"
              class="sidearm-mm__video-modal-player w-100 h-100 absolute"
            ></div>

            <iframe
              v-else-if="video.type === 'allaccess' && video.id"
              :src="
                `/showcase/embed.aspx?Archive=${video.id}&autoplay=true&dimTheLights=true`
              "
              class="sidearm-mm__video-modal-player absolute w-100 h-100"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
      default: () => ({
        type: "",
        id: ""
      })
    }
  },

  data: () => ({
    id: null,

    player: null,

    video_modal_open: false
  }),

  watch: {
    video_modal_open(newVal) {
      if (newVal && this.video.type === "youtube" && this.player) {
        this.player.playVideo();
      }

      if (!newVal && this.video.type === "youtube" && this.player) {
        this.player.pauseVideo();
      }
    }
  },

  methods: {
    toggle_video_modal(value) {
      if (value !== undefined) {
        this.video_modal_open = !!value;
      } else {
        this.video_modal_open = !this.video_modal_open;
      }
    },

    open() {
      this.toggle_video_modal(true);
    }
  },

  mounted() {
    this.id = this._uid;

    this.$nextTick(() => {
      if (!this.player && this.video.type === "youtube" && window.YT) {
        this.player = new window.YT.Player(`modal_video${this.id}`, {
          height: "315",
          width: "560",
          videoId: this.video.id
        });
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}__video-modal {
  @include hide();

  background-color: rgba($color-black, 0.8);
  opacity: 0;

  &.is-toggled {
    @include unhide();

    height: 100%;
    left: 0;
    opacity: 1;
    position: fixed;
    top: 0;
    transition: opacity 0.4s;
    width: 100%;
    z-index: 101;
  }

  &-inner {
    left: 50%;
    max-height: 90vh;
    max-width: 1440px;
    padding: 16px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }

  &-header {
    @include flex-item(0 0 auto);
  }

  &-player-container {
    @include flex-item(1 1 auto);
  }

  &-player-wrapper {
    padding-bottom: 56.25%;
  }

  &-close {
    @include base-reset();

    color: $color-white;
  }
}
</style>
